<template>
  <div class="deliver-wrap">
    <!-- <div class="deliver-wrap"> -->
    <new-common-banner
      v-zpm="{
        sectionid: 126,
        sortname: state.whetherShowPosteriorQcStyle == 0 ? '送至' : '后验配送',
        sortid: 0,
        other: state.whetherShowPosteriorQcStyle == 0 ? '送至' : '后验配送',
        areaexposure: state.whetherShowPosteriorQcStyle == 0 ? 126 : 149,
        legoareabackup: {
          sortName: state.whetherShowPosteriorQcStyle == 0 ? '配送栏曝光' : '后验配送栏曝光'
        }
      }"
      title=""
      :icon="icon"
    >
      <div class="process-item">
        <div class="item_address" @click="deliverClick">
          <span class="title">送至</span>
          <span class="title_info">{{ sendAddress }}</span>
          <span class="discountIcon" v-if="dataInfo && dataInfo.infoType === 2">包邮</span>
        </div>
        <div class="item_info" @click.stop="openDeliveryPop">
          <span class="item_info_tag" v-if="state.whetherShowPosteriorQcStyle === 1"
            >发货前复检</span
          >
          <span>{{ deliveryInfo.summarizeDesc }}</span>
          <span class="see" v-if="showSeeStatus">查看</span>
        </div>
      </div>
    </new-common-banner>

    <delivery-dialog
      ref="deliveryDialogRef"
      v-if="layerData && Object.keys(layerData).length > 0"
      :deliveryData="deliveryBar"
    />

    <DeliveryPicker
      ref="deliveryPickerRef"
      v-if="dialogList && dialogList.length"
      :deliveryData="dialogList"
    />
  </div>
</template>

<script>
import { defineComponent, onMounted, ref, computed } from '@vue/composition-api'
import newCommonBanner from '@/components/new-common-banner.vue'
import deliveryDialog from './DeliveryDialog.vue'
import DeliveryPicker from './DeliveryPicker.vue'
import { skipToUrl, chooseAddress, isPlatform } from '@utils/native'
import { login } from '@/lib/decorator/login'
import { useDecorator } from '@/lib/useDecorator'
import { state, setState } from '@/store/index'

export default defineComponent({
  components: {
    newCommonBanner,
    deliveryDialog,
    DeliveryPicker
  },
  props: {
    deliveryInfo: {
      type: Object,
      default: () => ({})
    },
    dataInfo: {
      type: Object,
      default: () => ({})
    }
  },
  setup(props, ctx) {
    const parent = { ...ctx }
    const { $legoAreaExposure } = ctx.root
    const deliveryDialogRef = ref(null)
    const deliveryPickerRef = ref(null)
    const showPromise = ref(false)

    const icon = ref(
      'https://pic3.zhuanstatic.com/zhuanzh/62a64a39-464e-47a8-9ac1-7a77a6d65618.png'
    )

    const deliveryBar = computed(() => {
      const data = props.deliveryInfo?.layerData || {}
      return data
    })

    const sendAddress = computed(() => {
      const {
        addressJson: { province = '', city = '' }
      } = state
      return `${province}${city}`.replace(/ /g, '')
    })

    /**
     * $ 后验数据
     */
    const layerData = computed(() => {
      return props.deliveryInfo?.layerData || []
    })

    /**
     * $ 二奢服务流程信息
     */
    // TODO: 二奢融合
    const dialogList = computed(() => {
      const result = props.deliveryInfo?.dialogList || []
      return result
    })

    /**
     * $ 是否展示查看 按钮
     */
    const showSeeStatus = computed(() => {
      if (props.dataInfo.infoType == 1000) {
        return layerData.value && Object.keys(layerData.value).length > 0
      }
      return dialogList.value && dialogList.value.length
    })

    /**
     * $ 查看按钮点击 （后验 + 二奢配送地址栏 服务流程）
     */
    // TODO: 二奢融合 待RD与PM确认后决定
    const openDeliveryPop = () => {
      if (props.dataInfo?.infoType != 1000) {
        deliveryPickerRef.value?.open()
      } else {
        deliveryDialogRef.value?.open()
      }
    }

    onMounted(() => {
      $legoAreaExposure()
    })

    // $ 跳转用户地址
    const deliverClick = useDecorator(() => {
      parent.emit('ensureClick')
      if (isPlatform('zz')) {
        chooseAddress((res) => {
          const addressJson = res?.addressJson || {}
          if (Object.keys(addressJson).length > 0) {
            setState({ addressId: addressJson.id })
            setState({ addressJson })
          }
        })
      } else {
        const url = `https://m.zhuanzhuan.com/trade/user-address/index.html?orderId=''&hasonShow=1&url=${encodeURIComponent(
          window.location.href
        )}#/myAddress`
        skipToUrl({
          targetUrl: url
        })
      }
    }, login)

    return {
      deliverClick,
      showPromise,
      icon,
      sendAddress,
      state,
      deliveryDialogRef,
      deliveryBar,
      openDeliveryPop,
      layerData,
      showSeeStatus,
      dialogList,
      deliveryPickerRef
    }
  }
})
</script>

<style lang="scss" scoped>
@import '@zz-common/zz-ui/lib/style/mixins/hairline.scss';
@import '@zz-common/zz-ui/lib/style/mixins/ellipsis.scss';
.discountIcon {
  position: relative;
  width: 56px;
  height: 28px;
  margin: 0 0 0 8px;
  padding: 4px 8px;
  color: #111;
  font-weight: 300;
  font-size: 20px;
  font-family: PingFangSC-Light, PingFang SC;
  line-height: 28px;
  background: linear-gradient(166deg, #f1e0ff 0%, #e0fffe 100%);
  border-radius: 4px;
  opacity: 0.9;
}

.see {
  position: relative;
  margin: 0 0 0 8px;
  padding-bottom: 1px;
  &::after {
    @include hairline(#d8d8d8);
    border-bottom-width: 1px;
  }
}
</style>
